<template>
  <div>
    <label :for="identification">
      <input
        type="checkbox"
        :class="className"
        :id="identification"
        @change="sendUpdate"
        :name="inputName"
        :checked="checked" />
        {{ inputLabel }}
    </label>
  </div>
</template>

<script>
export default {
  data () {
    return {
      checked: false
    }
  },
  props: {
    className: String,
    sideValue: {
      type: Object,
      required: false
    },
    identification: String,
    inputName: {
      type: String,
      required: true
    },
    inputLabel: String
  },
  methods: {
    receiveUpdate (value) {
      // ...
    },
    sendUpdate (e) {
      this.checked = !this.checked
      let rtr = {
        value: this.checked,
        input: this.inputName,
        extra: this.sideValue
      }
      this.$emit('fieldUpdate', rtr)
    }
  }
}
</script>

<style scoped>
input[type=checkbox] {
  transform: scale(1.5);
  margin-right: 15px;
  cursor: pointer;
}
label {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/standard/input/InputCheckbox.vue?0c76eda2